import { useTranslation } from 'react-i18next';
import { Button } from '@/index';
import Emptystate from '@/components/TableEmptyState/LibsTableEmptyState';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TranslationNS } from '@gokrew/models/constants';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(TranslationNS.LibsCommon);

  return (
    <div className="min-h-screen flex  flex-col items-center justify-center bg-gray-50 space-y-8 flex ">
      <Emptystate
        Icon={AlertTriangle}
        title={t('not_found.title')}
        message={t('not_found.message')}
        className="mt-10"
      />
      <Button
        variant="outline"
        type="submit"
        onClick={() => {
          navigate('/login');
        }}
      >
        {t('not_found.home_button')}
      </Button>
    </div>
  );
}
